<template>
  <logged-in-layout>
    <main :class="$style.container">
      <section>
        <h1>Ongoing Meetings</h1>
        <p v-if="ongoingActivitiesFetched && ongoingActivities.length === 0" :class="$style.noOngoingMeetings">There are no ongoing meetings right now</p>
        <OngoingMeetings v-else />
      </section>

      <h1>Upcoming Meetings</h1>
      <a :href="scheduleUrl" target="_blank" class="btn">Schedule Meeting</a>
      <InstantInviteModalTrigger v-slot="{ showModal }" :class="$style.instantInviteModalTrigger" class="btn">
        <button @click="showModal">Invite Notetaker</button>
      </InstantInviteModalTrigger>

      <upcoming-meeting />
    </main>
  </logged-in-layout>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import LoggedInLayout from '@/components/logged-in-layout/logged-in-layout'
  import store from '@/lib/store'
  import InstantInviteModalTrigger from '@/components/shared/InstantInvite/InstantInviteModalTrigger'
  import OngoingMeetings from '@/components/shared/OngoingMeetings'
  import UpcomingMeeting from './upcoming-meeting/upcoming-meeting'

  const GOOGLE_CALENDAR_LINK = 'https://calendar.google.com/calendar/render?action=TEMPLATE'
  const OFFICE_CALENDAR_LINK = 'https://outlook.office.com/calendar/0/deeplink/compose'
  const { mapState: mapGlobalState } = createNamespacedHelpers('global')

  export default {
    components: {
      LoggedInLayout,
      OngoingMeetings,
      UpcomingMeeting,
      InstantInviteModalTrigger
    },
    data () {
      return {
        team: store.get('team')
      }
    },
    computed: {
      ...mapGlobalState([
        'ongoingActivities',
        'ongoingActivitiesFetched'
      ]),
      scheduleUrl () {
        return this.team.calendarProvider === 'google'
          ? GOOGLE_CALENDAR_LINK
          : OFFICE_CALENDAR_LINK
      }
    },
    mounted () {
      const query = this.$route.query

      if (query.instant_invite) {
        this.isInstantInviteOpened = true
      }
    }
  }
</script>

<style module lang="less" src="./meetings.less"></style>



// WEBPACK FOOTER //
// meetings.vue?ee1f9594